import { HtmlDataProcessor } from "@oracle/ortl/src/engine.js";
import html2markdown, { turndownService } from "./html2markdown/html2markdown.mjs";

export default class GFMDataProcessor {
    constructor( document, markdown2html ) {
        this._htmlDP = new HtmlDataProcessor( document );
        this.markdown2html = markdown2html;
    }

    keepHtml( element ) {
        turndownService.keep( [ element ] );
    }

    toView( data ) {
        const html = this.markdown2html( data );
        return this._htmlDP.toView( html );
    }

    toData( viewFragment ) {
        const html = this._htmlDP.toData( viewFragment );
        return html2markdown( html );
    }

    useFillerType() { }
}